import { html, LitElement } from 'lit';
import * as de from '../../../lib/i18n/de.js';

import {
  timeIntervalsToCalendarEvents,
} from '../../../lib/time-interval-openings-converter.js';
import {
  formatDate,
  formatTime,
  isFullDayEvent,
} from '../../../lib/helper/src/date-helper.js';

class D1iOpeningHours extends LitElement {
  static get is() {
    return 'd1i-opening-hours';
  }

  static get properties() {
    return {
      timeIntervalOpenings: {
        type: Array,
        attribute: 'time-interval-openings',
      },
    };
  }

  constructor() {
    super();
    this.timeIntervalOpenings = [];
    this.hideEnd = false;
  }

  createRenderRoot() {
    return this;
  }

  /**
   * @return {TemplateResult<1>}
   */
  render() {
    const calendarEvents = timeIntervalsToCalendarEvents(this.timeIntervalOpenings)
      .filter(calendarEvent => calendarEvent.isActiveOrAfter(new Date()))
      .sort((calendarEventA, calendarEventB) => {
        if (calendarEventA.rrule?.options?.byweekday?.length === 0 || calendarEventB.rrule?.options?.byweekday?.length === 0) {
          return 0;
        }
        return calendarEventA.rrule?.options?.byweekday[0] - calendarEventB.rrule?.options?.byweekday[0];
      });

    return html`
      ${calendarEvents.map(calendarEvent => D1iOpeningHours.renderEvent(calendarEvent))}`;
  }

  /**
   *
   * @param {CalendarEvent} calendarEvent
   * @return {TemplateResult<1>}
   */
  static renderEvent(calendarEvent) {
    let dayText = formatDate(calendarEvent.getStartDate());
    let fromText = null;
    if (calendarEvent.isRecurring()) {
      const rrule = calendarEvent.getRRule();

      dayText = de.default.fixTranslationErrors(
        rrule.toText(de.default.getText, de.default.language,
          de.default.dateFormat),
      );

      const endOfToday = new Date();
      endOfToday.setHours(223, 59, 59);

      if (calendarEvent.getStartDate().getTime() > endOfToday.getTime() || rrule.options.count !== null) {
        fromText = `${de.default.getText('from')} ${formatDate(calendarEvent.getStartDate())}`;
      }
    }

    const startDate = calendarEvent.getStartDate();
    const endDate = calendarEvent.getEndDate();

    let timeText = formatTime(startDate);
    if (isFullDayEvent(startDate, endDate)) {
      timeText = de.default.getText('allDay');
    } else if (calendarEvent.showEnd()) {
      timeText += ` - ${formatTime(endDate)}`;
    }

    return html`
        <p class="d1i-opening-hours__table-day">
          ${fromText ? html`${fromText}` : html``}
          ${dayText}
        </p>
        <p class="d1i-opening-hours__table-time">${timeText}</p>
    `;
  }
}

customElements.define(D1iOpeningHours.is, D1iOpeningHours);
